import actionFe from 'utils/mw/actionFe.util';

export const feSetClientProfileBookingsCounts = actionFe('feSetClientProfileBookingsCounts');
export const feSetClientProfileData = actionFe('feSetClientProfileData');
